import { render } from "./CounselView.vue?vue&type=template&id=39c949ae"
import script from "./CounselView.vue?vue&type=script&lang=js"
export * from "./CounselView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__